import { isNil } from 'lodash-es';
import { StationType, VerticalStationColor } from '../../const';

export const calcWidth = (width: number | string, withoutChildren?: any[]) => {
  if (typeof width === 'string') return width;
  return withoutChildren?.length === 1
    ? width
    : (width - 8 * (withoutChildren ?? []).length - 1) / (withoutChildren ?? []).length;
};

export const calcMinWidth = (width: number | string) => {
  if (typeof width === 'string') return 160;
  return width === 500 ? 161 : 160;
};

export const style = (isShowBorder: boolean) => ({
  border: !isShowBorder ? 'none' : '1px solid var(--mx-card-dark-bg-color)',
  background: !isShowBorder ? 'none' : 'rgba(74, 144, 226, 0.2)',
  padding: !isShowBorder ? '0px' : '8px',
});

export const calcProcessColor = (rate: number | null) => {
  if (!rate) return 'transparent';
  if (rate < 75) return '#16DD8E';
  if (rate < 85) return '#FFCB47';
  if (rate < 95) return '#FF9247';
  return '#FF4D4F';
};

export const noChildWrapperStyle = (level: number, width: number | string, withoutChildren?: any[], item?: any) => {
  const widthValue = typeof width === 'string' ? width : `${calcWidth(width, withoutChildren)}px`;
  return {
    background: VerticalStationColor[level],
    minWidth: `${calcMinWidth(width)}px`,
    width: widthValue,
    cursor: item?.type === StationType.DistributionStation ? 'pointer' : 'unset',
  };
};

const getCardMinHeight = (monitorCount: number) => (monitorCount > 0 ? 38 + monitorCount * 49 : 40);

export const getStationCardMinHeight = (item?: any) => {
  const monitorCount = (item?.monitorItemList ?? []).filter((monitorItem: any) => !isNil(monitorItem.loadRate)).length;
  return getCardMinHeight(monitorCount);
};

export const calcPadding = (item?: any, noPBtoom?: boolean) => {
  const res = (item?.monitorItemList ?? []).some((x: any) => !isNil(x.loadRate));
  return noPBtoom ? (res ? 8 : 0) : res ? 0 : 8;
};
